import React from 'react';
import { useLoaderData } from 'react-router-dom';

import InboundShowView from '@components/shared/inbounds/InboundShow';
import { useAdminInboundService } from '@hooks/admin/inbounds/useAdminInboundService';
import { thirdPartyApiLogService } from '@services/admin/thirdPartyApiLogService';

export default function InboundShow() {
  const inbound = useLoaderData();

  return (
    <InboundShowView
      inbound={inbound}
      useInboundService={useAdminInboundService}
      thirdPartyApiLogService={thirdPartyApiLogService}
      role="admin"
    />
  );
}
